/* Provencelia, 13/10/2026 : bulle de chat plus discrète sur mobile (< 700 px uniquement).
   Le widget (console.provencelia.com) vit dans un shadow DOM ouvert : on y ajoute une règle
   qui réduit le bouton de 60 à 48 px. Rien ne change sur desktop. */
(function () {
  'use strict';
  var mq = window.matchMedia('(max-width: 699px)');
  var ID = 'pv-chat-mobile';
  var CSS = '@media (max-width: 699px){.launch{width:48px !important;height:48px !important}.launch svg{width:22px;height:22px}}';

  function appliquer() {
    var hote = document.getElementById('pvc-chat-root');
    var racine = hote && hote.shadowRoot;
    if (!racine) return false;
    if (!racine.getElementById(ID)) {
      var style = document.createElement('style');
      style.id = ID;
      style.textContent = CSS;
      racine.appendChild(style);
    }
    return true;
  }

  function lancer() {
    if (!mq.matches) return;
    if (appliquer()) return;
    // Le widget se charge en différé : on attend son apparition (10 s au plus).
    var obs = new MutationObserver(function () {
      if (appliquer()) obs.disconnect();
    });
    obs.observe(document.body, { childList: true });
    setTimeout(function () { obs.disconnect(); }, 10000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', lancer);
  } else {
    lancer();
  }
})();
